import { ApolloQueryResult, useQuery } from '@apollo/client';
import { useMemo } from 'react';

import { isDemoEnvironment } from '../../../../constants/global';
import { handleGql403 } from '../../../../utils';
import { GetLastFourNotificationsQuery, GetLastFourNotificationsQueryVariables } from '../../types';
import { mockNotificationsByUser } from '../useGetNotificationsByUser/mock';
import { GET_LAST_FOUR_NOTIFICATIONS_BY_USER } from './getLastFourNotifications';

export type UseGetLastFourNotifications = {
  notifications: GetLastFourNotificationsQuery['getNotificationsByUser']['edges'][0]['node'][];
  loading: boolean;
  refetch(): Promise<ApolloQueryResult<GetLastFourNotificationsQuery>>;
};

const useGetLastFourNotifications = (userId: string): UseGetLastFourNotifications => {
  const { data, loading, refetch } = useQuery<GetLastFourNotificationsQuery, GetLastFourNotificationsQueryVariables>(
    GET_LAST_FOUR_NOTIFICATIONS_BY_USER,
    {
      variables: {
        userId,
      },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
      onError: handleGql403,
      skip: !userId,
    }
  );

  const notifications = useMemo(() => {
    return (data?.getNotificationsByUser?.edges || []).map((item) => item.node);
  }, [data]);

  const mockedRefetch = (): Promise<ApolloQueryResult<GetLastFourNotificationsQuery>> =>
    Promise.resolve({} as ApolloQueryResult<GetLastFourNotificationsQuery>);

  return {
    notifications: isDemoEnvironment ? mockNotificationsByUser.slice(0, 4) : notifications,
    loading,
    refetch: isDemoEnvironment ? mockedRefetch : refetch,
  };
};

export default useGetLastFourNotifications;
